import { BOT_MODE, SCREEN_TYPE } from 'consts/enum';
import { addClass, animation, focusElement, removeClass } from 'helpers/helpers';
import { ENGT_CHAT } from 'js/bot.model';
import PopupTemplate from './popup.template';

export const PopupComponent = {
	init() {
		const showChatScreen = () => {
			removeClass(document.getElementById('engt-popup'), 'engt-launch-screen-open');
			addClass(document.getElementById('engt-popup'), 'engt-chat-screen-open');
			ENGT_CHAT.get('reRenderChatScreen')();
			ENGT_CHAT.set('currentScreen', SCREEN_TYPE.CHAT);
			animation.messagesIn();
			animation.launchScreenOut();
			focusElement('.engt-common-header');
		};

		const showLaunchScreen = () => {
			if (ENGT_CHAT.get('config.bot_mode') === BOT_MODE.WIDGET) {
				removeClass(document.getElementById('engt-popup'), 'engt-chat-screen-open');
				addClass(document.getElementById('engt-popup'), 'engt-launch-screen-open');
				ENGT_CHAT.get('reRenderLaunchScreen')();
				ENGT_CHAT.get('hideMinimizedCallout')();
				ENGT_CHAT.set('currentScreen', SCREEN_TYPE.LAUNCH);
				animation.messagesOut();
				animation.launchScreenIn();
				focusElement('.engt-common-header');
			}
		};

		const getCurrentScreen = () => ENGT_CHAT.get('currentScreen');

		ENGT_CHAT.set('showChatScreen', showChatScreen);
		ENGT_CHAT.set('showLaunchScreen', showLaunchScreen);
		ENGT_CHAT.set('getCurrentScreen', getCurrentScreen);
	},

	render(data) {
		return PopupTemplate(data);
	},
};
